var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"url":_vm.getCurrentUrl}}),_c('header-block'),_c('router-view'),_c('notification-block')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e","hasScoped":false,"transformToRequire":{"video":"src","source":["src","srcset"],"vector":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = mPh3
// module chunks = 1